<template>
  <div ref="load">
    <v-progress-linear
      indeterminate
      color="primary"
      height="2"
    ></v-progress-linear>
    <div class="text-center text-caption px-4 pt-2">
       Carregando mais opções...
    </div>
  </div>
</template>

<script>
export default {
  props: {
    infiniteScroll: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    observer: null,
  }),
  mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll);
    this.observer.observe(this.$refs.load);
  },
  beforeDestroy() {
    this.observer.disconnect();
    this.observer = null;
  },
}
</script>
